<template>

    <div class="buttons">
        <hr />
        <button @click.prevent="handleNext" class="btn btn-success btn-lg float-right" >
            Next >>
        </button>
        <!-- <button @click.prevent="handlePrev" class="btn btn-light float-right" >Go back</button> -->
        <button @click.prevent="handleReset" class="btn btn-lg btn-danger " >Start Over</button>
    </div>
</template>

<script>
export default {
    methods: {
        handleNext(){
            this.$root.$emit('goToNextForm')
        },
        handlePrev(){
            this.$root.$emit('goToPrevForm')
        },
        handleReset(){
            this.$root.$emit('goToResetForm')
        }        
    }
}
</script>
